const target = document.querySelector('sht-dialog-quickshop');

if (target) {
  const observer = new MutationObserver(() => {
    const isHidden = target.getAttribute('hidden') === 'true';
    const hasQtyTable = document.querySelector('.bss-b2b-cart-item-qty-table');

    if (!isHidden && !hasQtyTable) {
      document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
    }
  });

  observer.observe(target, {
    attributes: true,
    attributeFilter: ['hidden']
  });
}


document.addEventListener("DOMContentLoaded", () => {
    const inputSearchSelector = `input[type='search']`;
    let debounceTimer;
    document.addEventListener("input", (e) => {
        if (e.target && e.target.matches(inputSearchSelector)) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                window.dispatchEvent(new Event('scroll'));
            }, 300);
        }
    });
}); 